import {
  SET_LEADS,
  UPDATE_LEAD_STATUS,
  UPDATE_LEAD_TRANSCRIPT,
  ADD_TRANSCRIPT_MESSAGE,
  CLEAR_TRANSCRIPT_MESSAGES,
  SET_LOADING,
} from "./actions";

const initialState = {
  leads: [],
  isLoading: false,
  transcriptMessages: {}, // Store real-time transcript messages by leadId
};

const outboundCallsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_LEADS:
      return {
        ...state,
        leads: action.payload,
      };

    case UPDATE_LEAD_STATUS:
      return {
        ...state,
        leads: state.leads.map((lead) =>
          lead.id === action.payload.leadId
            ? {
                ...lead,
                status: action.payload.status,
                vapiCallId: action.payload.vapiCallId,
                callStartedAt: action.payload.callStartedAt,
                callEndedAt: action.payload.callEndedAt,
                lastCalledAt: action.payload.lastCalledAt,
              }
            : lead
        ),
      };

    case UPDATE_LEAD_TRANSCRIPT:
      return {
        ...state,
        leads: state.leads.map((lead) =>
          lead.id === action.payload.leadId
            ? {
                ...lead,
                transcript: action.payload.transcript,
                summary: action.payload.summary,
                recordingUrl: action.payload.recordingUrl,
                lastCallDuration: action.payload.duration,
              }
            : lead
        ),
      };

    case ADD_TRANSCRIPT_MESSAGE:
      return {
        ...state,
        transcriptMessages: {
          ...state.transcriptMessages,
          [action.payload.leadId]: [
            ...(state.transcriptMessages[action.payload.leadId] || []),
            {
              role: action.payload.role,
              message: action.payload.message,
              time: action.payload.time,
              duration: action.payload.duration,
              timestamp: action.payload.timestamp,
            },
          ],
        },
      };

    case CLEAR_TRANSCRIPT_MESSAGES:
      return {
        ...state,
        transcriptMessages: {
          ...state.transcriptMessages,
          [action.payload]: [],
        },
      };

    case SET_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };

    default:
      return state;
  }
};

export default outboundCallsReducer;
